/**
 * Sidebar Module
 *
 * Handles sidebar navigation submenu toggles and mobile menu.
 * Auto-initializes on page load.
 */

import { $, $$, ready } from '../utils/dom.js';

/**
 * Initialize a submenu toggle
 * @param {string} menuId - The menu button ID (e.g., 'menu-orders')
 */
function initSubmenuToggle(menuId) {
    const btn = document.getElementById(menuId);
    const sub = document.getElementById(`sub${menuId.replace('menu-', 'menu-')}`);
    const caret = document.getElementById(`${menuId}-caret`);

    // Also try alternate naming pattern
    const subAlt = document.getElementById(menuId.replace('menu-', 'submenu-'));

    const submenu = sub || subAlt;

    if (!btn || !submenu) return;

    btn.addEventListener('click', () => {
        const isHidden = submenu.classList.contains('hidden');
        submenu.classList.toggle('hidden');

        if (caret) {
            if (isHidden) {
                caret.classList.add('rotate-180');
            } else {
                caret.classList.remove('rotate-180');
            }
        }
    });
}

/**
 * Initialize mobile sidebar toggle
 */
function initMobileToggle() {
    const mobileBtn = document.getElementById('mobileMenuBtn');
    const sidebar = document.getElementById('sidebar');

    if (!mobileBtn || !sidebar) return;

    mobileBtn.addEventListener('click', () => {
        const isHidden = sidebar.classList.contains('-translate-x-full');
        if (isHidden) {
            sidebar.classList.remove('-translate-x-full');
        } else {
            sidebar.classList.add('-translate-x-full');
        }
    });
}

/**
 * Initialize restaurant selector dropdown
 */
function initRestaurantSelector() {
    const selector = document.getElementById('restaurant-selector');
    const dropdown = document.getElementById('restaurant-dropdown');

    if (!selector || !dropdown) return;

    selector.addEventListener('click', (e) => {
        e.preventDefault();
        dropdown.classList.toggle('hidden');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
        if (!selector.contains(e.target) && !dropdown.contains(e.target)) {
            dropdown.classList.add('hidden');
        }
    });
}

/**
 * Auto-initialize all sidebar functionality using data attributes
 * Usage: <button data-submenu-toggle="orders">Orders</button>
 *        <div data-submenu="orders" class="hidden">...</div>
 */
function initDataAttributeToggles() {
    $$('[data-submenu-toggle]').forEach(btn => {
        const menuName = btn.dataset.submenuToggle;
        const submenu = $(`[data-submenu="${menuName}"]`);
        const caret = $('[data-submenu-caret]', btn) || btn.querySelector('.submenu-caret');

        if (!submenu) return;

        btn.addEventListener('click', () => {
            const isHidden = submenu.classList.contains('hidden');
            submenu.classList.toggle('hidden');

            if (caret) {
                caret.classList.toggle('rotate-180', isHidden);
            }
        });
    });
}

/**
 * Initialize sidebar
 */
export function init() {
    // Initialize known submenus
    const menus = [
        'menu-orders',
        'menu-menu',
        'menu-inventory',
        'menu-promotions',
        'menu-analytics',
        'menu-customers',
        'menu-restaurant',
        'menu-website',
        'menu-subscriptions',
        'menu-users'
    ];

    menus.forEach(initSubmenuToggle);

    // Initialize mobile toggle
    initMobileToggle();

    // Initialize restaurant selector
    initRestaurantSelector();

    // Initialize data attribute based toggles
    initDataAttributeToggles();
}

// Auto-initialize on DOM ready
ready(init);

export default {
    init,
    initSubmenuToggle,
    initMobileToggle,
    initRestaurantSelector
};
